import createReducer from 'redux/lib/reducerConfig';

export const ActionTypes = {
  SET_CURRENCIES: 'CURRENCY_PLANS/SET_CURRENCIES',
};

const initState = {
  data: [],
};

export const currencyPlansReducer = createReducer(
  initState,
  {
    [ActionTypes.SET_CURRENCIES]: (state, action) => {
      return {
        ...state,
        data: action.payload,
      };
    },
  }
);
